import React from "react";
import ReactApexChart from "react-apexcharts";
import { Typography, Spin } from "antd";
import moment from "moment";

function LineChart({ activeUsersByDate, newUsersByDate, loading, dateRange, viewType, showTitle = true, height = 350 }) {
  const { Title } = Typography;
  if (loading) {
    return (
      <div style={{ minHeight: height, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin tip="Loading chart..." />
      </div>
    );
  }
  if (!dateRange?.[0] || !dateRange?.[1]) return null;

  const [start, end] = dateRange;
  const isMonthly = viewType === "monthly";

  let categories = [];
  let activeSeries = [];
  let newSeries = [];

  if (!isMonthly) {
    // -------- DAILY --------
    const allDates = [];
    let current = moment(start);
    const last = moment(end);
    while (current.isSameOrBefore(last)) {
      allDates.push(current.format("YYYY-MM-DD"));
      current.add(1, "day");
    }

    const activeMap = {};
    activeUsersByDate.forEach(i => {
      activeMap[i.date] = i.users ?? i.unique_active_users;
    });

    const newMap = {};
    newUsersByDate.forEach(i => {
      newMap[i.date] = i.new_users_count;
    });

    categories = allDates;
    activeSeries = allDates.map(d => activeMap[d] || 0);
    newSeries = allDates.map(d => newMap[d] || 0);
  } else {
    // -------- MONTHLY --------
    const activeMonthMap = {};
    activeUsersByDate.forEach(i => {
      const m = moment(i.date).format("MMM YYYY");
      activeMonthMap[m] =
        (activeMonthMap[m] || 0) + (i.users ?? i.unique_active_users);
    });

    const newMonthMap = {};
    newUsersByDate.forEach(i => {
      const m = moment(i.date).format("MMM YYYY");
      newMonthMap[m] = (newMonthMap[m] || 0) + i.new_users_count;
    });

    // Build months from selected range
    let current = moment(start).startOf("month");
    const last = moment(end).startOf("month");
    while (current.isSameOrBefore(last)) {
      const key = current.format("MMM YYYY");
      categories.push(key);
      activeSeries.push(activeMonthMap[key] || 0);
      newSeries.push(newMonthMap[key] || 0);
      current.add(1, "month");
    }
  }

  const chartSeries = [
    { name: "Active Users", data: activeSeries },
    { name: "New Users", data: newSeries },
  ];

  const chartOptions = {
    chart: { type: "area", height, toolbar: { show: false } },
    stroke: { curve: "smooth", width: 2 },
    dataLabels: { enabled: false },
    legend: { show: true },
    xaxis: { categories },
    yaxis: { min: 0, title: { text: "Users" } },
    tooltip: { y: { formatter: val => `${val} users` } },
  };

  return (
    <>
      {showTitle ? (
        <Title level={5}>
          Users Overview ({isMonthly ? "Monthly" : "Daily"})
        </Title>
      ) : null}
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="area"
        height={height}
        width="100%"
      />
    </>
  );
}

export default LineChart;
